import { Inject, Injectable } from '@angular/core';
import { catchError, filter, map, Observable, of, switchMap, tap } from 'rxjs';

import { OktaInterfaceService } from '@shure/cloud/shared/okta/data-access';

import { CloudFeatureFlagsService, FEATURE_FLAG_SERVICE } from './cloud-feature-flags.service';

@Injectable({ providedIn: 'root' })
export class CloudFeatureFlagsInitializationService {
	private isInitialized = false;

	constructor(
		private readonly oktaIntfService: OktaInterfaceService,
		@Inject(FEATURE_FLAG_SERVICE) private readonly featureFlagsService: CloudFeatureFlagsService
	) {}

	public initialize$(setUserConfig: boolean): Observable<boolean> {
		if (this.isInitialized) {
			return of(true);
		}

		const statsigLoadingPipeline$ = this.featureFlagsService.isLoading$.pipe(
			filter((isLoading) => !isLoading),
			tap(() => {
				this.isInitialized = true;
			}),
			map(() => true)
		);

		if (setUserConfig) {
			return this.oktaIntfService.getUserProfile$().pipe(
				filter((userProfile) => !!userProfile.userId),
				switchMap((userProfile) => {
					return this.featureFlagsService.setConfig$({
						userID: userProfile.userId,
						custom: {
							orgID: userProfile.orgId
						}
					});
				}),
				// Swallow errors, they don't impact functionality and get logged by the setConfig$ call
				// Can remove once https://jira.shure.com/browse/CLP-2333 is complete
				catchError(() => of(true)),
				switchMap(() => statsigLoadingPipeline$)
			);
		}

		return statsigLoadingPipeline$;
	}
}
